'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _papaparse = require('papaparse');

var _papaparse2 = _interopRequireDefault(_papaparse);

var _ShopifySection2 = require('./../../sections/ShopifySection');

var _ShopifySection3 = require('./../ShopifySection');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Magnet Finder
 *
 *
 *  Version:
 *    1.0.0 - 2020/07/21
 */

var CONTAINER_SELECTOR = '[data-magnet-finder]';
var CSV_SELECTOR = '[data-magnet-finder-csv]';
var SHAPE_SELECTOR = '[data-shape]';
var SIZE_SELECTOR = '[data-size]';
var STRENGTH_SELECTOR = '[data-strength]';
var MATERIAL_SELECTOR = '[data-material]';
var COATING_SELECTOR = '[data-coating]';

var MagnetFinder = function (_ShopifySection) {
  (0, _inherits3.default)(MagnetFinder, _ShopifySection);

  function MagnetFinder(container) {
    (0, _classCallCheck3.default)(this, MagnetFinder);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MagnetFinder.__proto__ || Object.getPrototypeOf(MagnetFinder)).call(this, container));

    _this.shapeSelect = container.find(SHAPE_SELECTOR);
    _this.sizeSelect = container.find(SIZE_SELECTOR);
    _this.strengthSelect = container.find(STRENGTH_SELECTOR);
    _this.materialSelect = container.find(MATERIAL_SELECTOR);
    _this.coatingSelect = container.find(COATING_SELECTOR);

    var csv = container.find(CSV_SELECTOR).text();
    var data = _papaparse2.default.parse(csv).data;
    var headers = ['shape', 'size', 'strength', 'material', 'coating'];

    //Fill blank rows with populated value above
    for (var i = 0; i < data.length; i++) {
      for (var j = 0; j < 5; j++) {
        if (data[i][j] == '') data[i][j] = data[i - 1][j];
      }
    }

    //Pull unique data for select options
    var optionsData = {};
    headers.forEach(function (header) {
      return optionsData[header] = [];
    });
    data.forEach(function (row) {
      return row.forEach(function (cell, i) {
        var headerForCell = headers[i];
        if (optionsData[headerForCell].indexOf(cell) !== -1) return;
        optionsData[headerForCell].push(cell);
      });
    });

    optionsData.shape.forEach(function (shape) {
      _this.shapeSelect.append('<option value="' + shape + '">' + shape + '</option>');
    });
    optionsData.size.forEach(function (size) {
      _this.sizeSelect.append('<option value="' + size + '">' + size + '</option>');
    });
    optionsData.strength.forEach(function (strength) {
      _this.strengthSelect.append('<option value="' + strength + '">' + strength + '</option>');
    });
    optionsData.material.forEach(function (material) {
      _this.materialSelect.append('<option value="' + material + '">' + material + '</option>');
    });
    optionsData.coating.forEach(function (coating) {
      _this.coatingSelect.append('<option value="' + coating + '">' + coating + '</option>');
    });
    return _this;
  }

  return MagnetFinder;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection3.register)(CONTAINER_SELECTOR, MagnetFinder);